import Vue, { CreateElement } from 'vue'

import { Component, Prop } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'

import { Element, SelectableElement } from '@src/mixins/element/element'
import { Selectable } from '@src/mixins/selectable/selectable'
import { IconLanguageSwitch } from '@src/components/language-switch/language-switch'
import { ProfileOptions } from '@src/routes/platform/profile-options'
import { H6 } from '@src/elements/typography/typography'

import './sidebar.sass'
import './portrait.sass'

@Component
export class Badge extends Vue {

  @Prop({ required: true })
  label: string

  render (h: CreateElement) {
    return (
      <div class='badge'>
        <p>{this.label}</p>
      </div>
    )
  }

}

@Component
export class NavItem extends Mixins<SelectableElement>(Element, Selectable) {

  @Prop({ required: false })
  badge: string

  render (h: CreateElement) {
    let styleClasses = [
      ...this.elementStyles,
      ...this.selectableStyles,

      ...this.navItemStyles
    ]

    return (
      this.renderElement(h, styleClasses, this.disabled, [
        this.renderIcon(h),
        this.renderLabel(h),

        this.renderBadge(h)
      ])
    )
  }

  protected renderBadge (h: CreateElement) {
    return (!this.badge) ? null :
      <Badge label={this.badge} />
  }

  protected get navItemStyles () {
    return ['nav-item']
  }

}

@Component
export class ProfileNavItem extends NavItem {

  render (h: CreateElement) {
    let styleClasses = [
      ...this.elementStyles,
      ...this.selectableStyles,

      ...this.navItemStyles,
      'profile-nav-item'
    ]

    return (
      this.renderElement(h, styleClasses, this.disabled, [
        this.renderLabel(h),
        this.renderOptions(h)
      ])
    )
  }

  protected renderLabel (h: CreateElement) {
    return <H6>{this.label}</H6>
  }

  protected renderOptions (h: CreateElement) {
    return <div class='profile-options'>
      <IconLanguageSwitch />
      <ProfileOptions />
    </div>
  }
}

@Component
export class Sidebar extends Vue {

  render (h: CreateElement) {
    return (
      <div class='sidebar'>

        <div class='slot top'>
          {this.$slots.top}
        </div>

        <div class='slot default'>
          {this.$slots.default}
        </div>

        <div class='slot bottom'>
          {this.$slots.bottom}
        </div>

      </div>
    )
  }

}
